import { FormSuccess } from '../../../components/FormSuccess'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'

export default function BrilhaMagentaCompletePage() {
  return (
    <PublicFormLayout title="Brilha Magenta">
      <FormSuccess
        title="Brilha Magenta Concluído!"
        description="Feedback registrado com sucesso!"
        notes={[
          'Não se esqueça do Princípio Sagrado #8º "Aqui o Feedback é o melhor presente. Cobrança é reconhecimento de potencial."',
          '#ABRACEVAI 👊'
        ]}
        actions={[
          { label: 'Retornar para página inicial', to: '/brilha-magenta', loggedOnly: true },
          { label: 'Realizar um novo Brilha Magenta', to: '/brilha-magenta/new' }
        ]}
      />
    </PublicFormLayout>
  )
}
